import {
  IconDotsVertical,
  IconEdit,
  IconRobot,
  IconSearch,
  IconKey,
  IconToggleLeft,
  IconToggleRight,
  IconTrash,
  IconBrain,
  IconBrandWhatsapp,
  IconAlertTriangle,
  IconCopy,
  IconSettings,
  IconPlugOff,
  IconPlug,
  IconPlugConnected,
} from "@tabler/icons-react";
import { useContext, useEffect, useState, useCallback } from "react";
import {
  Container as BSContainer,
  Row,
  Col,
  Card,
  Dropdown,
  Modal,
  Spinner,
  Button,
  Form,
  Badge,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import NumberFormat from "react-number-format";
import Swal from "sweetalert2";
import NotificationsContext from "../contexts/NotificationsContext";
import UserContext from "../contexts/UserContext";
import AgentChat from "../jsx/components/Agents/AgentChat";
import DefaultLoader from "../jsx/components/Loader";
import NotificationsModal from "../jsx/components/ModalData/NotificationsModal";
import NotificationService from "../services/NotificationsServices";
import {
  ConnectWhatsappAccount,
  GetAgentsData,
  UpdateAgentStatus,
  UpdateAgentVersion,
  updateSession,
  CheckAccountStatus,
  GetWhatsappFeatureUsage,
} from "../services/WaBottyServices";
import { useNavigate } from "react-router-dom";
import {
  deleteAgent,
  updateAgent,
  patchAgent,
  duplicateAgent,
} from "../services/AgentsServices.js";
import {
  formatPhoneForAPI,
  formatPhoneNumber,
} from "../helpers/Helpers.js";
import WhatsappConnect from "../jsx/components/WhatsAppChat/WhatsappConnect";
import PublicationsServices from "./Publications/services/PublicationsServices";

export default function WhatsappAgents() {
  const navigate = useNavigate();

  const { user, bottyData, isSubaccount, getUserPlan, canPerformAdminActions } =
    useContext(UserContext);
  const { setNotify } = useContext(NotificationsContext);

  const [showAgentsData, setAgentsData] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);
  const [selectedAgentData, setSelectedAgentData] = useState(null);
  const [notificationConfig, setNotificationConfig] = useState({
    keyword: "",
    notificationTypes: [],
    phone: "",
  });
  const [loadingNotifications, setLoadingNotifications] = useState(false);

  // Estados para Fireworks
  const [showFireworks, setShowFireworks] = useState(false);

  // Novos estados para as funcionalidades adicionadas
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  const [selectedAgentForApiKey, setSelectedAgentForApiKey] = useState(null);
  const [apiKeyValue, setApiKeyValue] = useState("");
  const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");
  const [delayEnabled, setDelayEnabled] = useState(false);
  const [delayTime, setDelayTime] = useState(20);
  const [isUpdatingApiKey, setIsUpdatingApiKey] = useState(false);
  const [useDefaultApiKey, setUseDefaultApiKey] = useState(false);
  const [defaultApiKey, setDefaultApiKey] = useState("");
  const [showAgentChat, setShowAgentChat] = useState(false);
  const [selectedAgentForChat, setSelectedAgentForChat] = useState(null);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [isUpdatingVersion, setIsUpdatingVersion] = useState(false);

  // Estados para modal de conectar integração
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showWhatsappConnect, setShowWhatsappConnect] = useState(false);
  const [selectedAgentForConnect, setSelectedAgentForConnect] = useState(null);
  const [isGeneratingSession, setIsGeneratingSession] = useState(false);
  const [isWaitingForSession, setIsWaitingForSession] = useState(false);
  const [sessionCheckAttempts, setSessionCheckAttempts] = useState(0);

  // Estado para modal explicativo dos modelos
  const [showModelsExplanationModal, setShowModelsExplanationModal] =
    useState(false);

  // Estados para loading das operações de vincular/desvincular
  const [isLinking, setIsLinking] = useState(false);
  const [isUnlinking, setIsUnlinking] = useState(false);

  // Estados para controle de uso da feature WhatsApp
  const [whatsappUsageRemaining, setWhatsappUsageRemaining] = useState(null);
  const [isLoadingFeature, setIsLoadingFeature] = useState(false);

  // Estados para paginação manual
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreAgents, setHasMoreAgents] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [totalAgents, setTotalAgents] = useState(0);
  const itemsPerPage = 10;

  // Função para carregar mais agentes
  const loadMoreAgents = useCallback(async () => {
    if (isLoadingMore || !hasMoreAgents || isLoading) return;

    setIsLoadingMore(true);
    try {
      const nextPage = currentPage + 1;
      const response = await GetAgentsData(nextPage, itemsPerPage);

      if (response && response.results && response.results.length > 0) {
        setAgentsData((prev) => [...prev, ...response.results]);
        setCurrentPage(nextPage);
        setHasMoreAgents(response.next); // Baseado no campo 'next' da API
        setTotalAgents(response.count);
      } else {
        setHasMoreAgents(false);
      }
    } catch (error) {
      console.error("Erro ao carregar mais agentes:", error);
      setNotify({
        type: "danger",
        message: "Erro ao carregar mais agentes",
        title: "Erro",
        visible: true,
      });
    } finally {
      setIsLoadingMore(false);
    }
  }, [currentPage, hasMoreAgents, isLoadingMore, isLoading, setNotify]);

  // Função para retry manual
  // const retryLoadMore = useCallback(() => {
  //   loadMoreAgents();
  // }, [loadMoreAgents]);

  // Carrega os dados dos agentes
  const loadAgentsData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await GetAgentsData(1, itemsPerPage);
      setAgentsData(response?.results || []);
      setFilteredAgents(response?.results || []);
      setCurrentPage(1);
      setHasMoreAgents(response?.next || false);
      setTotalAgents(response?.count || 0);
    } catch (err) {
      console.error("Erro ao carregar agentes:", err);
      setNotify({
        type: "danger",
        message: "Erro ao carregar agentes",
        title: "Erro",
        visible: true,
      });
    } finally {
      setIsLoading(false);
    }
  }, [setNotify]);

  useEffect(() => {
    loadAgentsData();
  }, [loadAgentsData]);

  // Filter agents based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredAgents(showAgentsData);
    } else {
      const filtered = showAgentsData.filter(
        (agent) =>
          agent.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          agent.model?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          agent.agent_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          agent.agent_job?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredAgents(filtered);
    }
  }, [searchTerm, showAgentsData]);

  // Carrega as configurações de notificação
  const loadNotificationConfig = async () => {
    if (!bottyData?.uid) return;

    setLoadingNotifications(true);
    try {
      const data = await NotificationService.getCurrentConfig();

      if (data && !data.notificationTypes && data.notification_types) {
        data.notificationTypes = data.notification_types.map((type) => ({
          value: type,
          label:
            type === "whatsapp"
              ? "Mensagem no WhatsApp"
              : "Mensagem na Plataforma",
        }));
      }

      setNotificationConfig(data);
    } catch (error) {
      console.error("Erro ao carregar configurações de notificação:", error);
      setNotify({
        type: "danger",
        message: "Erro ao carregar configurações de notificação",
        title: "Erro",
        visible: true,
      });
    } finally {
      setLoadingNotifications(false);
    }
  };

  // Salva as configurações de notificação
  const handleSaveNotificationConfig = async (data) => {
    try {
      let result;

      if (data.id) {
        result = await NotificationService.updateConfig(data.id, data);
      } else {
        result = await NotificationService.saveConfig(data);
      }

      if (result.notificationTypes) {
        delete result.id;
        delete result.created_at;
        delete result.notificationTypes;
      }

      let notifications = {
        notifications: result,
      };
      localStorage.removeItem("__accsettings");
      localStorage.setItem("__accsettings", JSON.stringify(notifications));
      setNotify({
        title: "Sucesso!",
        type: "success",
        message: "Configurações de notificação salvas com sucesso!",
        visible: false,
      });

      if (result && !result.notificationTypes && result.notification_types) {
        result.notificationTypes = result.notification_types.map((type) => ({
          value: type,
          label:
            type === "whatsapp"
              ? "Mensagem no WhatsApp"
              : "Mensagem na Plataforma",
        }));
      }

      setNotificationConfig(result);
      setShowNotificationsModal(false);
    } catch (error) {
      console.error("Erro ao salvar configurações de notificação:", error);
      setNotify({
        title: "Oops!",
        type: "error",
        message: "Erro ao salvar configurações de notificação",
        visible: false,
      });
    }
  };

  // Abre o modal de notificações
  const handleOpenNotificationsModal = () => {
    loadNotificationConfig();
    setShowNotificationsModal(true);
  };

  // Função para editar agente - refatorada
  const handleEditAgent = (agent) => {
    if (!agent) {
      setNotify({
        type: "warning",
        message: "Dados do agente não encontrados",
        title: "Atenção",
      });
      return;
    }

    // Verificar se é um agente criado por prompt
    if (agent.raw_prompt && agent.raw_prompt.trim() !== "") {
      // Redirecionar para o componente de prompt
      navigate("/agents/create", {
        state: {
          creationType: "prompt",
          editData: {
            agentName: agent.agent_name || agent.name || "",
            agentJob: agent.agent_job || "",
            promptText: agent.raw_prompt || "",
            id: agent.id,
            // Outros dados necessários
            model: agent.model,
            is_active: agent.is_active,
            is_published: agent.is_published,
          },
          isEditing: true,
        },
      });
    } else {
      // Redirecionar para o editor normal
      navigate(`/agents/${agent.id}`, {
        state: {
          data: agent,
          isEditing: true,
        },
      });
    }
  };

  // Função para criar novo agente
  const handleCreateAgent = () => {
    setSelectedAgentData(null);
    navigate(`/agents/create`, {
      state: {
        data: null,
        isEditing: false,
      },
    });
  };

  // Função para abrir modal de API Key
  const handleOpenApiKeyModal = (agent) => {
    setSelectedAgentForApiKey(agent);

    // Verificar se existe api_key no localStorage
    let localStorageApiKey = "";
    let hasDefaultApiKey = false;

    try {
      const accSettings = localStorage.getItem("__accsettings");
      if (accSettings) {
        const parsedSettings = JSON.parse(accSettings);
        if (parsedSettings.api_key) {
          localStorageApiKey = parsedSettings.api_key;
          hasDefaultApiKey = true;
        }
      }
    } catch (error) {
      console.error("Erro ao ler localStorage __accsettings:", error);
    }

    setDefaultApiKey(localStorageApiKey);

    // Se o agente não tem api_key mas existe uma padrão, usar ela
    if (!agent.api_key && hasDefaultApiKey) {
      setUseDefaultApiKey(true);
      setApiKeyValue(localStorageApiKey);
    } else {
      setUseDefaultApiKey(false);
      setApiKeyValue(agent.api_key || "");
    }

    setSelectedModel(agent.model || "gpt-4.1-mini");
    setDelayEnabled(agent.delay === 1 || agent.delay === true);
    setDelayTime(agent.delay_time || 20);
    setShowApiKeyModal(true);
  };

  // Função para verificar se existe conta WhatsApp conectada no contexto
  const hasBottyAccount = () => {
    return (
      bottyData &&
      Array.isArray(bottyData) &&
      bottyData.length > 0 &&
      bottyData &&
      bottyData[0]?.phone
    );
  };

  // Função para verificar se deve mostrar opção de vincular (conta STOPPED)
  const shouldShowLinkOption = () => {
    return (
      (bottyData &&
        Array.isArray(bottyData) &&
        bottyData.length > 0 &&
        bottyData[0]?.status === "STOPPED") ||
      (bottyData && bottyData[0]?.agent_id === null)
    );
  };

  // Função para verificar se já existe agente conectado e plano é 3
  const shouldHideVincularOption = () => {
    const userPlanId = getUserPlan();
    if (userPlanId !== 3) return false;

    // Verificar se qualquer agente já tem WhatsApp conectado
    return showAgentsData.some(
      (agent) => agent.wabotty_account && agent.wabotty_account.trim() !== ""
    );
  };

  // Função para obter status do WhatsApp baseado no bottyData
  const getWhatsappStatus = (agentWabottyAccount, currentAgentId) => {
    if (!agentWabottyAccount || agentWabottyAccount.trim() === "") {
      return null; // Sem WhatsApp conectado
    }

    // Buscar no bottyData pelo número do agente
    const waAccount = bottyData?.find((account) => {
      const accountPhone = account.phone?.replace("+", "");
      const agentPhone = agentWabottyAccount.replace("+", "");
      return accountPhone === agentPhone;
    });

    if (waAccount) {
      const status = waAccount.status;
      const isAgentLinked =
        waAccount.agent_id &&
        String(waAccount.agent_id) === String(currentAgentId);

      switch (status) {
        case "WORKING":
          if (isAgentLinked) {
            return {
              status: "WORKING",
              color: "success",
              text: "Conectado e Ativo",
              description: "WhatsApp conectado e agente respondendo",
            };
          } else {
            return {
              status: "WORKING_NOT_LINKED",
              color: "warning",
              text: "Não Vinculado",
              description: "WhatsApp conectado mas agente não vinculado",
            };
          }
        case "STOPPED":
          return {
            status: "STOPPED",
            color: "secondary",
            text: "Instância Parada",
            description: "WhatsApp conectado mas instância parada",
          };
        case "SCAN_QR_CODE":
          return {
            status: "SCAN_QR_CODE",
            color: "warning",
            text: "Aguardando QR Code",
            description: "Escaneie o QR Code para conectar",
          };
        case "FAILED":
          return {
            status: "FAILED",
            color: "danger",
            text: "Falha na Conexão",
            description: "Erro ao conectar com WhatsApp",
          };
        default:
          return {
            status: "UNKNOWN",
            color: "light",
            text: "Status Desconhecido",
            description:
              "Vinculado mas com falha. Desvincule e conecte novamente.",
          };
      }
    }

    // Se tem wabotty_account mas não encontrou no bottyData
    return {
      status: "UNKNOWN",
      color: "light",
      text: "Status Desconhecido",
      description: "Não foi possível verificar o status",
    };
  };

  // Função para abrir modal de conectar integração
  const handleOpenConnectModal = async (agent) => {
    setSelectedAgentForConnect(agent);
    setPhoneNumber("");
    setShowWhatsappConnect(false);
    setShowConnectModal(true);

    // Verificar uso restante da feature WhatsApp
    setIsLoadingFeature(true);
    try {
      const featureResult = await GetWhatsappFeatureUsage();
      if (featureResult.success) {
        setWhatsappUsageRemaining(featureResult.usage_remaining);
      } else {
        // Em caso de erro, bloquear conexão (usage_remaining = 0)
        setWhatsappUsageRemaining(0);
        console.error("Erro ao verificar feature WhatsApp:", featureResult.error);
      }
    } catch (error) {
      console.error("Erro ao verificar feature WhatsApp:", error);
      setWhatsappUsageRemaining(0);
    } finally {
      setIsLoadingFeature(false);
    }
  };

  // Função para vincular conta WhatsApp já conectada ao agente
  const handleLinkExistingAccount = async (agent) => {
    if (!hasBottyAccount()) {
      setNotify({
        type: "warning",
        message: "Nenhuma conta WhatsApp encontrada para vincular",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    const bottyAccount = bottyData[0]; // Primeira conta disponível
    const rawPhoneNumber =
      bottyAccount.phone || bottyAccount.number || "Número não disponível";

    const result = await Swal.fire({
      title: "Vincular Conta WhatsApp",
      html: `
        <div style="text-align: left; margin: 20px 0;">
          <p><strong>Agente:</strong> ${agent.agent_name}</p>
          <p><strong>Conta WhatsApp:</strong> ${formatPhoneNumber(
            rawPhoneNumber
          )}</p>
          <br>
          <p style="color: #6c757d; font-size: 14px;">
            Deseja vincular esta conta WhatsApp já conectada ao agente selecionado?
          </p>
          <div style="background: #d1ecf1; border: 1px solid #bee5eb; border-radius: 8px; padding: 12px; margin: 12px 0;">
            <p style="color: #0c5460; font-size: 13px; margin: 0;">
              <strong>💡 Info:</strong> O agente passará a responder mensagens nesta conta automaticamente.
            </p>
          </div>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, vincular",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "var(--primary)",
      cancelButtonColor: "#6c757d",
    });

    if (result.isConfirmed) {
      setIsLinking(true);

      // Mostrar loading durante a operação
      Swal.fire({
        title: "Vinculando agente...",
        html: `Aguarde enquanto vinculamos o agente "${agent.agent_name}" ao WhatsApp.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        // Usar número bruto diretamente do bottyData (já no formato correto)
        const formattedPhoneForAPI = rawPhoneNumber.replace("+", "");

        // Chamar a nova API de updateSession para vincular agente
        const response = await updateSession(
          formattedPhoneForAPI,
          "link",
          agent.id
        );

        if (response.success) {
          // Fechar o loading
          Swal.close();

          // Atualizar estado local
          setAgentsData((prev) =>
            prev.map((agentItem) =>
              agentItem.id === agent.id
                ? { ...agentItem, wabotty_account: formattedPhoneForAPI }
                : agentItem
            )
          );

          sessionStorage.removeItem("botty_account");

          setNotify({
            type: "success",
            message:
              response.data.message ||
              `Agente "${agent.agent_name}" vinculado com sucesso ao WhatsApp!`,
            title: "Vinculação Realizada",
            visible: true,
          });

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          throw new Error(response.error || "Erro na vinculação");
        }
      } catch (error) {
        // Fechar o loading em caso de erro
        Swal.close();

        console.error("Erro ao vincular agente:", error);
        setNotify({
          type: "error",
          message: error.message || "Erro ao vincular agente à conta WhatsApp",
          title: "Erro",
          visible: true,
        });
      } finally {
        setIsLinking(false);
      }
    }
  };

  // Função para verificar status da sessão periodicamente
  const checkSessionStatus = async (phone, agentId, intervalId, timeoutId) => {
    try {
      setSessionCheckAttempts((prev) => prev + 1);
      const result = await CheckAccountStatus(phone, agentId);

      // Verificar se o status está presente diretamente no result ou em result.data
      const status = result.status || result.data?.status;

      if (status === "WORKING" || status === "SCAN_QR_CODE") {
        // Status WORKING ou SCAN_QR_CODE encontrado - limpar intervalos e prosseguir
        clearInterval(intervalId);
        clearTimeout(timeoutId);

        Swal.close();
        setIsWaitingForSession(false);
        setShowWhatsappConnect(true);

        return true;
      }

      return false;
    } catch (error) {
      console.error("Erro ao verificar status da sessão:", error);
      return false;
    }
  };

  // Função para gerar a sessão
  const handleGenerateSession = async () => {
    const cleanPhone = phoneNumber.replace(/\D/g, "");
    if (
      !phoneNumber ||
      (cleanPhone.length !== 10 && cleanPhone.length !== 11)
    ) {
      setNotify({
        type: "warning",
        message:
          "Por favor, insira um número de telefone válido (10 ou 11 dígitos)",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    setIsGeneratingSession(true);
    setSessionCheckAttempts(0);

    try {
      // ✅ Chamar ConnectWhatsappAccount para iniciar sessão com phone e agent_id
      const connectParams = {
        account_id: user?.account_id,
        phone: cleanPhone,
        agent_id: selectedAgentForConnect?.id || null,
      };

      const response = await ConnectWhatsappAccount(connectParams);

      if (response?.status === "STARTING") {
        setIsWaitingForSession(true);

        // Mostrar loading enquanto aguarda status WORKING
        Swal.fire({
          title: "Aguardando sessão inicializar...",
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p>Aguarde enquanto a sessão do WhatsApp é iniciada.</p>
              <p><strong>Isso pode levar até 2 minutos.</strong></p>
              <div style="background: #e3f2fd; padding: 12px; border-radius: 8px; margin-top: 16px;">
                <small style="color: #1976d2;">
                  ⏱️ Verificando status...
                </small>
              </div>
            </div>
          `,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Configurar verificação periódica
        const intervalId = setInterval(() => {
          checkSessionStatus(
            cleanPhone,
            selectedAgentForConnect?.id,
            intervalId,
            timeoutId
          );
        }, 3000);

        // Timeout de 2 minutos (120 segundos)
        const timeoutId = setTimeout(() => {
          clearInterval(intervalId);
          setIsWaitingForSession(false);

          Swal.fire({
            icon: "warning",
            title: "Timeout na Inicialização",
            html: `
              <div style="text-align: left;">
                <p>A sessão do WhatsApp não conseguiu inicializar em 2 minutos.</p>
                <br>
                <p><strong>Possíveis causas:</strong></p>
                <ul style="text-align: left; margin-left: 20px;">
                  <li>Problemas de conectividade</li>
                  <li>Sobrecarga no servidor</li>
                  <li>Número já em uso</li>
                </ul>
                <br>
                <p>Tente novamente em alguns minutos.</p>
              </div>
            `,
            confirmButtonText: "Entendi",
            confirmButtonColor: "#f39c12",
          });
        }, 120000); // 2 minutos
      } else {
        setNotify({
          type: "error",
          message:
            "Oops, tivemos um problema ao iniciar sua sessão do WhatsApp, por favor, tente novamente.",
          title: "Erro",
          visible: true,
        });
      }
    } catch (error) {
      console.error("Erro ao iniciar sessão WhatsApp:", error);

      const errorData = error?.data || error?.response?.data;
      const status = error?.status || error?.response?.status;

      if (errorData?.requires_payment) {
        // Limite de conexões excedido — modal com CTA pra contratar mais.
        const usageInfo =
          errorData.current_usage != null && errorData.total_limit != null
            ? `<p><strong>Uso atual:</strong> ${errorData.current_usage}/${errorData.total_limit} conexões</p>`
            : "";
        const extraInfo = errorData.extra_value
          ? `<p><strong>Valor por conexão adicional:</strong> R$ ${errorData.extra_value}</p>`
          : "";
        Swal.fire({
          icon: "info",
          title: "Limite de Conexões WhatsApp",
          html: `
            <div style="text-align: left;">
              <p>${errorData.error || "Você atingiu o limite de conexões do seu plano."}</p>
              ${usageInfo}
              ${extraInfo}
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Contratar Agora",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3b82f6",
          cancelButtonColor: "#6c757d",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/subscriptions");
          }
        });
      } else if (status === 422) {
        setShowWhatsappConnect(true);
      } else if (errorData?.error) {
        // Mensagem específica do backend — mostrar pro usuário em vez de engolir.
        Swal.fire({
          icon: "error",
          title: "Erro ao iniciar sessão",
          text: errorData.error,
          confirmButtonColor: "#3b82f6",
        });
      } else {
        setNotify({
          type: "error",
          message:
            "Oops, tivemos um problema ao iniciar sua sessão do WhatsApp, por favor, tente novamente.",
          title: "Erro",
          visible: true,
        });
      }
    } finally {
      setIsGeneratingSession(false);
    }
  };

  // Função para fechar modal de conectar
  const handleCloseConnectModal = () => {
    setShowConnectModal(false);
    setSelectedAgentForConnect(null);
    setPhoneNumber("");
    setShowWhatsappConnect(false);
    setIsGeneratingSession(false);
  };

  // Função para navegar para integrações
  const handleManageIntegrations = () => {
    window.location.href = "/channels";
  };

  // Callback para quando conexão for bem-sucedida (chamado pelo WhatsappConnect)
  const handleConnectionSuccess = async (
    phoneData,
    isLinking = false,
    targetAgent = null,
    preFormattedPhone = null
  ) => {
    try {
      // Usar targetAgent se fornecido, senão usar selectedAgentForConnect
      const agentToUpdate = targetAgent || selectedAgentForConnect;

      if (!agentToUpdate) {
        throw new Error("Nenhum agente selecionado para conectar");
      }

      // Usar número pré-formatado se fornecido, senão usar o fluxo original
      const formattedPhone =
        preFormattedPhone || formatPhoneForAPI(phoneNumber).replace("+", "");

      // Atualizar agente
      await updateAgent(agentToUpdate.id, {
        wabotty_account: formattedPhone,
      });

      // Atualizar estado local
      setAgentsData((prev) =>
        prev.map((agent) =>
          agent.id === agentToUpdate.id
            ? { ...agent, wabotty_account: formattedPhone }
            : agent
        )
      );

      sessionStorage.removeItem("botty_account");

      setNotify({
        type: "success",
        message: `Agente "${agentToUpdate.agent_name}" ${
          isLinking ? "vinculado" : "conectado"
        } com sucesso ao WhatsApp!`,
        title: isLinking ? "Vinculação Realizada" : "Conexão Realizada",
        visible: true,
      });

      // Fechar modal
      handleCloseConnectModal();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Erro ao atualizar agente:", error);
      setNotify({
        type: "error",
        message: `Erro ao ${
          isLinking ? "vincular" : "conectar"
        } agente ao WhatsApp`,
        title: "Erro",
        visible: true,
      });
    }
  };

  // Callback para quando todas as tentativas falharem (chamado pelo WhatsappConnect)
  const handleConnectionFailure = () => {
    setNotify({
      type: "error",
      message:
        "Não foi possível conectar após 3 tentativas. Tente novamente mais tarde.",
      title: "Falha na Conexão",
      visible: true,
    });
    handleCloseConnectModal();
  };

  const handleDeleteAgent = async (agent) => {
    if (agent.is_active) {
      setNotify({
        type: "warning",
        message:
          "Este agente está ativo e funcionando em seu whatsapp. Desative-o antes de excluir.",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    const result = await Swal.fire({
      title: "Excluir agente?",
      html: `Você tem certeza que deseja excluir o agente "${agent.agent_name}"? <br>Tudo relacionado ao agente será excluído, como produtos, imagens, arquivos e etc...</br><b>Esta ação não pode ser revertida, tenha certeza absoluta antes de realizar esta ação!</b>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
    });

    if (result.isConfirmed) {
      // Mostrar loading enquanto processa a exclusão
      Swal.fire({
        title: "Excluindo agente...",
        html: `<div style="text-align: center; padding: 20px;">
                 <div style="margin-bottom: 15px;">
                   <div class="spinner-border text-danger" role="status">
                     <span class="visually-hidden">Carregando...</span>
                   </div>
                 </div>
                 <p style="margin-bottom: 0; color: #6c757d;">
                   Aguarde enquanto excluímos o agente "<strong>${agent.agent_name}</strong>"...
                 </p>
               </div>`,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        backdrop: true,
      });

      try {
        await deleteAgent(agent.id);
        setAgentsData((prev) => prev.filter((a) => a.id !== agent.id));

        // Fechar loading e mostrar sucesso
        Swal.fire({
          icon: "success",
          title: "Agente Excluído!",
          html: `<div style="text-align: center; padding: 10px;">
                   <p>O agente "<strong>${agent.agent_name}</strong>" foi excluído com sucesso!</p>
                   <p style="color: #6c757d; font-size: 14px; margin-bottom: 0;">
                     Todos os dados relacionados foram removidos.
                   </p>
                 </div>`,
          confirmButtonText: "Entendi",
          confirmButtonColor: "#28a745",
          timer: 3000,
          timerProgressBar: true,
        });

        setNotify({
          type: "success",
          message: `Agente "${agent.agent_name}" excluído com sucesso!`,
          title: "Sucesso",
          visible: true,
        });
      } catch (error) {
        console.error("Erro ao excluir agente:", error);

        // Fechar loading e mostrar erro
        Swal.fire({
          icon: "error",
          title: "Erro ao Excluir",
          html: `<div style="text-align: center; padding: 10px;">
                   <p>Ocorreu um erro ao excluir o agente "<strong>${agent.agent_name}</strong>".</p>
                   <p style="color: #6c757d; font-size: 14px; margin-bottom: 0;">
                     Tente novamente ou entre em contato com o suporte se o problema persistir.
                   </p>
                 </div>`,
          confirmButtonText: "Fechar",
          confirmButtonColor: "#dc3545",
        });

        setNotify({
          type: "danger",
          message: "Erro ao excluir agente",
          title: "Erro",
          visible: true,
        });
      }
    }
  };

  const handleDisconnectAgent = async (agent) => {
    // Verificar se o agente tem WhatsApp conectado
    if (!agent.wabotty_account || agent.wabotty_account.trim() === "") {
      setNotify({
        type: "warning",
        message:
          "Este agente não possui uma conexão WhatsApp ativa para desvincular.",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    const result = await Swal.fire({
      title: "Desvincular agente do WhatsApp?",
      html: `
        <div style="text-align: left; margin: 20px 0;">
          <p><strong>Agente:</strong> ${agent.agent_name}</p>
          <p><strong>Número WhatsApp:</strong> ${formatPhoneNumber(
            agent.wabotty_account
          )}</p>
          <br>
          <p style="color: #6c757d; font-size: 14px;">
            Ao desvincular, este número ficará disponível para ser conectado em outro agente.
            O agente atual ficará sem conexão WhatsApp ativa.
          </p>
          <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 12px; margin: 12px 0;">
            <p style="color: #856404; font-size: 13px; margin: 0;">
              <strong>⚠️ Atenção:</strong> Esta ação irá interromper todas as conversas ativas deste agente no WhatsApp.
            </p>
          </div>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, desvincular",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    });

    if (result.isConfirmed) {
      setIsUnlinking(true);

      // Mostrar loading durante a operação
      Swal.fire({
        title: "Desconectando agente...",
        html: `Aguarde enquanto desconectamos o agente "${agent.agent_name}" do WhatsApp.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        // Usar o número formatado para API (sem +)
        const formattedPhoneForAPI = agent.wabotty_account.replace("+", "");
      
        // Chamar a nova API de updateSession para desvincular agente
        const response = await updateSession(formattedPhoneForAPI, "unlink");

        if (response.success) {
          // Fechar o loading
          Swal.close();

          // Atualizar estado local
          setAgentsData((prev) =>
            prev.map((a) =>
              a.id === agent.id ? { ...a, wabotty_account: "" } : a
            )
          );
          setNotify({
            type: "success",
            message:
              response.data.message ||
              `Agente "${
                agent.agent_name
              }" desconectado do WhatsApp com sucesso! O número ${formatPhoneNumber(
                agent.wabotty_account
              )} agora está disponível para outro agente.`,
            title: "Desconectado",
            visible: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          throw new Error(response.error || "Erro na desconexão");
        }
      } catch (error) {
        // Fechar o loading em caso de erro
        Swal.close();

        console.error("Erro ao desvincular agente:", error);
        setNotify({
          type: "danger",
          message: error.message || "Erro ao desvincular agente do WhatsApp",
          title: "Erro",
          visible: true,
        });
      } finally {
        setIsUnlinking(false);
      }
    }
  };

  const handleDuplicateAgent = async (agent) => {
    const result = await Swal.fire({
      title: "Duplicar agente?",
      html: `Você tem certeza que deseja duplicar o agente "${agent.agent_name}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, duplicar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#007bff",
    });

    if (result.isConfirmed) {
      try {
        await duplicateAgent(agent.id);
        setNotify({
          type: "success",
          message: `Agente "${agent.agent_name}" duplicado com sucesso!`,
          title: "Sucesso",
          visible: true,
        });

        setTimeout(() => {
          window.location.reload();
        }, 2500);
      } catch (error) {
        console.error("Erro ao duplicar agente:", error);

        let errorMessage = "Erro ao duplicar agente";
        let errorTitle = "Erro";

        if (error.response?.data) {
          const { error_code, error: apiError } = error.response.data;

          switch (error_code) {
            case "AGENT_ACCESS_DENIED":
              errorMessage = "Agente não pertence à sua conta";
              errorTitle = "Acesso Negado";
              break;
            case "AGENT_NOT_FOUND":
              errorMessage = "Agente não encontrado";
              errorTitle = "Não Encontrado";
              break;
            case "USER_NO_ACCOUNT":
              errorMessage = "Usuário não possui conta associada";
              errorTitle = "Erro de Conta";
              break;
            case "NAME_GENERATION_FAILED":
              errorMessage =
                "Não foi possível gerar nome único para o agente duplicado";
              errorTitle = "Erro de Nomeação";
              break;
            case "VALIDATION_ERROR":
              errorMessage = "Erro de validação ao criar agente duplicado";
              errorTitle = "Erro de Validação";
              break;
            case "AGENT_CREATION_FAILED":
              errorMessage = "Erro interno ao criar agente duplicado";
              errorTitle = "Erro de Criação";
              break;
            case "SERIALIZATION_ERROR":
              errorMessage = "Erro ao serializar agente duplicado";
              errorTitle = "Erro de Serialização";
              break;
            case "INTERNAL_SERVER_ERROR":
              errorMessage = "Erro interno do servidor";
              errorTitle = "Erro do Servidor";
              break;
            default:
              errorMessage = apiError || "Erro ao duplicar agente";
              break;
          }
        }

        setNotify({
          type: "danger",
          message: errorMessage,
          title: errorTitle,
          visible: true,
        });
      }
    }
  };

  // Função para publicar agente no marketplace
  const handlePublishAgent = async (agent) => {
    // Validações antes de publicar
    if (!agent.api_key || agent.api_key.trim() === "") {
      setNotify({
        type: "warning",
        message: "Configure a API Key antes de publicar o agente",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    if (!agent.is_active) {
      setNotify({
        type: "warning",
        message: "O agente deve estar ativo para ser publicado",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    // Modal de confirmação
    const result = await Swal.fire({
      title: "🚀 Publicar Agente no Marketplace",
      html: `
        <div style="text-align: left; margin: 20px 0;">
          <p><strong>Agente:</strong> ${agent.agent_name}</p>
          <p><strong>Função:</strong> ${agent.agent_job}</p>
          <p><strong>Versão:</strong> v.${agent.version_active}</p>
          <br>
          <p style="color: #6c757d; font-size: 15px;">
            Ao publicar, seu agente ficará disponível no marketplace. 
            Empresas poderão contratar seu agente e você receberá uma recorrência mensal por cada contratação.
          </p>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "✨ Sim, publicar!",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-secondary",
      },
      buttonsStyling: false,
    });

    if (!result.isConfirmed) return;

    try {
      // Mostrar loading durante a publicação
      Swal.fire({
        title: "Publicando agente...",
        html: "Aguarde enquanto enviamos seu agente para o marketplace",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      // Auto-gerar ID do marketplace baseado no agente
      const marketplaceId = `AGENT-${agent.id.toString().padStart(3, "0")}`;

      // Preparar dados para publicação
      const publicationData = {
        agent: agent.id,
        marketplace_product_id: marketplaceId,
      };

      // Simular delay da requisição (3 segundos)
      await new Promise((resolve) => setTimeout(resolve, 3000));

      // Fazer chamada para API de publicação
      const response = await PublicationsServices.createPublication(
        publicationData
      );

      // Fechar o loading
      Swal.close();

      if (response.data) {
        // Atualizar estado local do agente
        setAgentsData((prev) =>
          prev.map((a) =>
            a.id === agent.id ? { ...a, is_published: true } : a
          )
        );

        // Mostrar fireworks
        setShowFireworks(true);

        // Esconder fireworks após 4 segundos
        setTimeout(() => {
          setShowFireworks(false);
        }, 4000);

        // Mostrar notificação de sucesso
        setNotify({
          type: "success",
          message: `🎉 Agente "${agent.agent_name}" foi publicado no marketplace com sucesso! `,
          title: "Publicado com Sucesso!",
          visible: true,
        });

        // Modal de sucesso adicional
        const successResult = await Swal.fire({
          title: "🎉 Parabéns!",
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <div style="font-size: 64px; margin-bottom: 16px;">🚀</div>
              <h4 style="color: #28a745; margin-bottom: 16px;">Agente Publicado!</h4>
              <p style="color: #6c757d;">
                Seu agente "<strong>${agent.agent_name}</strong>" foi enviado para o marketplace.
              </p>
              <p style="color: #6c757d;">
                <strong>ID do Marketplace:</strong> ${response.data.marketplace_product_id}
              </p>
              <p style="color: #6c757d;">
                <strong>Status:</strong> ${response.data.status_display}
              </p>
              <p style="color: #6c757d; font-size: 14px; margin-top: 16px;">
                Você receberá notificações sobre o status da aprovação e quando outros usuários interagirem com seu agente.
              </p>
            </div>
          `,
          confirmButtonText: "Ver Publicações",
          confirmButtonColor: "#28a745",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-secondary",
          },
          buttonsStyling: false,
        });

        // Se o usuário clicar em "Ver Publicações", navegar para a tela de publicações
        if (successResult.isConfirmed) {
          navigate("/publications");
        }
      }
    } catch (error) {
      console.error("Erro ao publicar agente:", error);

      Swal.close();

      let errorMessage =
        "Erro ao publicar agente no marketplace. Tente novamente.";

      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.marketplace_product_id) {
        errorMessage = "ID do marketplace já existe. Tente um ID diferente.";
      } else if (error.response?.data?.agent) {
        errorMessage = "Este agente já foi publicado anteriormente.";
      }

      setNotify({
        type: "danger",
        message: errorMessage,
        title: "Erro na Publicação",
        visible: true,
      });
    }
  };

  // Função para salvar API Key
  const handleSaveApiKey = async () => {
    if (!selectedAgentForApiKey || !apiKeyValue.trim()) {
      setNotify({
        type: "warning",
        message: "Por favor, insira uma API Key válida",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    if (!apiKeyValue.trim().startsWith("sk-")) {
      setNotify({
        type: "warning",
        message: "API Key deve começar com 'sk-'",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    setIsUpdatingApiKey(true);
    try {
      const updateData = {
        api_key: apiKeyValue.trim(),
        model: selectedModel,
        delay: delayEnabled ? 1 : 0,
      };

      if (delayEnabled) {
        updateData.delay_time = delayTime;
      }

      await patchAgent(selectedAgentForApiKey.id, updateData);

      setAgentsData((prev) =>
        prev.map((agent) => {
          if (agent.id === selectedAgentForApiKey.id) {
            const updatedAgent = {
              ...agent,
              api_key: apiKeyValue.trim(),
              model: selectedModel,
              delay: delayEnabled ? 1 : 0,
            };

            if (delayEnabled) {
              updatedAgent.delay_time = delayTime;
            }

            return updatedAgent;
          }
          return agent;
        })
      );

      setNotify({
        type: "success",
        message: "Configurações atualizadas com sucesso!",
        title: "Sucesso",
        visible: true,
      });

      setShowApiKeyModal(false);
      setSelectedAgentForApiKey(null);
      setApiKeyValue("");
      setSelectedModel("gpt-4.1-mini");
    } catch (error) {
      console.error("Erro ao atualizar configurações:", error);
      setNotify({
        type: "danger",
        message: "Erro ao atualizar configurações",
        title: "Erro",
        visible: true,
      });
    } finally {
      setIsUpdatingApiKey(false);
    }
  };

  // Função para testar agente (abrir chat)
  const handleTestAgent = (agent) => {
    if (!agent.api_key || agent.api_key.trim() === "") {
      setNotify({
        type: "warning",
        message: "Configure a API Key antes de testar o agente",
        title: "Atenção",
        visible: true,
      });
      return;
    }

    setSelectedAgentForChat(agent);
    setShowAgentChat(true);
  };

  // Função para ativar/desativar agente
  const handleToggleAgentStatus = async (agent) => {
    const newStatus = !agent.is_active;
    const action = newStatus ? "ativar" : "desativar";

    // Verificar se tem API Key antes de ativar
    if (newStatus && (!agent.api_key || agent.api_key.trim() === "")) {
      Swal.fire({
        title: "API Key Necessária",
        text: "Você precisa configurar a API Key antes de ativar o agente.",
        icon: "info",
        confirmButtonText: "Configurar API Key",
        confirmButtonColor: "#007bff",
      }).then((result) => {
        if (result.isConfirmed) {
          handleOpenApiKeyModal(agent);
        }
      });
      return;
    }

    const result = await Swal.fire({
      title: `${action.charAt(0).toUpperCase() + action.slice(1)} agente?`,
      text: `Você tem certeza que deseja ${action} o agente "${agent.agent_name}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sim, ${action}`,
      cancelButtonText: "Cancelar",
      confirmButtonColor: newStatus ? "#28a745" : "#dc3545",
    });

    if (result.isConfirmed) {
      setIsUpdatingStatus(true);
      try {
        await UpdateAgentStatus(agent.id, newStatus);

        setAgentsData((prev) =>
          prev.map((a) =>
            a.id === agent.id ? { ...a, is_active: newStatus } : a
          )
        );

        setNotify({
          type: "success",
          message: `Agente ${
            newStatus ? "ativado" : "desativado"
          } com sucesso!`,
          title: "Sucesso",
          visible: true,
        });
      } catch (error) {
        console.error("Erro ao atualizar status do agente:", error);
        setNotify({
          type: "danger",
          message: "Erro ao atualizar status do agente",
          title: "Erro",
          visible: true,
        });
      } finally {
        setIsUpdatingStatus(false);
      }
    }
  };

  // Função para alterar versão do agente
  const handleChangeVersion = async (agent, newVersion) => {
    if (newVersion === agent.version_active) return;

    const result = await Swal.fire({
      title: "Alterar versão do agente?",
      text: `Você tem certeza que deseja alterar para a versão ${newVersion}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, alterar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#007bff",
    });

    if (result.isConfirmed) {
      setIsUpdatingVersion(true);
      try {
        await UpdateAgentVersion(agent.id, newVersion);

        setAgentsData((prev) =>
          prev.map((a) =>
            a.id === agent.id ? { ...a, version_active: newVersion } : a
          )
        );

        setNotify({
          type: "success",
          message: `Versão alterada para v.${newVersion} com sucesso!`,
          title: "Sucesso",
          visible: true,
        });
      } catch (error) {
        console.error("Erro ao alterar versão do agente:", error);
        setNotify({
          type: "danger",
          message: "Erro ao alterar versão do agente",
          title: "Erro",
          visible: true,
        });
      } finally {
        setIsUpdatingVersion(false);
      }
    }
  };

  // Função para gerar opções de versão
  const generateVersionOptions = (agent) => {
    const versions = [];
    const maxVersion = agent.version || 1;

    for (let i = 1; i <= maxVersion; i++) {
      versions.push(i);
    }

    return versions.reverse().slice(0, 10);
  };

  const getStats = () => {
    const total = showAgentsData.length;
    const active = showAgentsData.filter((agent) => agent.is_active).length;
    const models = [...new Set(showAgentsData.map((agent) => agent.model))]
      .length;

    return { total, active, models };
  };

  const stats = getStats();

  if (isLoading) {
    return (
      <BSContainer
        fluid
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "60vh" }}
      >
        <Spinner animation="border" variant="primary" size="lg" />
        <p className="mt-3 text-muted">Carregando agentes...</p>
      </BSContainer>
    );
  }

  return (
    <BSContainer fluid className="py-4 position-relative">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center gap-3">
          <div
            className="d-flex align-items-center justify-content-center rounded-lg"
            style={{
              width: "48px",
              height: "48px",
              background: "var(--primary)",
              color: "white",
            }}
          >
            <IconRobot size={24} />
          </div>
          <h2 className="mb-0 fw-bold text-dark">Meus Agentes</h2>
        </div>
      </div>

      {/* Search */}
      <div className="position-relative mb-4" style={{ maxWidth: "400px" }}>
        <div
          className="position-absolute start-0 top-50 translate-middle-y ms-3"
          style={{ color: "var(--text-muted)" }}
        >
          <IconSearch size={18} />
        </div>
        <input
          type="text"
          className="form-control ps-5"
          placeholder="Buscar agentes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            borderRadius: "var(--border-radius-md)",
            border: "2px solid var(--border-color)",
            fontSize: "16px",
          }}
        />
      </div>

      {/* Stats */}
      <Row className="g-3 mb-4">
        <Col xs={6} md={6}>
          <Card className="h-100 text-center border-0 shadow-sm hover-lift">
            <Card.Body className="py-3">
              <div className="fw-bold fs-4 ">{stats.total}</div>
              <div className="text-muted small text-uppercase fw-medium">
                Total
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={6}>
          <Card className="h-100 text-center border-0 shadow-sm hover-lift">
            <Card.Body className="py-3">
              <div className="fw-bold fs-4 ">{stats.active}</div>
              <div className="text-muted small text-uppercase fw-medium">
                Ativos
              </div>
            </Card.Body>
          </Card>
        </Col>
     
      </Row>

      {/* Actions Bar */}
      {/*  <div className="d-flex justify-content-between align-items-center mb-4">
        <div></div>
        <Button
          className="btn-primary d-flex align-items-center gap-2"
          onClick={handleOpenNotificationsModal}
        >
          <IconBellRinging size={18} />
          Notificações
        </Button>
      </div> */}

      {/* Agents Grid or Empty State */}
      {filteredAgents.length === 0 ? (
        <Card className="text-center border-0 shadow-sm">
          <Card.Body className="py-5">
            <div
              className="text-muted mb-3"
              style={{ fontSize: "4rem", opacity: 0.6 }}
            >
              🤖
            </div>
            <h3 className="fw-semibold text-secondary mb-2">
              {searchTerm
                ? "Nenhum agente encontrado"
                : "Nenhum agente configurado"}
            </h3>
            <p className="text-muted mb-4">
              {searchTerm
                ? "Tente ajustar sua busca para encontrar agentes."
                : "Comece configurando seu primeiro agente de IA para automatizar conversas."}
            </p>
          </Card.Body>
        </Card>
      ) : (
        <Row className="g-3 mb-5">
          {filteredAgents.map((agent, idx) => (
            <Col xs={12} sm={6} lg={4} xl={4} key={agent.id || idx}>
              <Card className="h-100 border-0 shadow-sm hover-lift position-relative">
                {/* Card Top Border */}
                <div className="position-absolute top-0 start-0 w-100" />

                <Card.Body className="p-4">
                  {/* Header with Icon and Dropdown */}
                  <div className="d-flex justify-content-between mb-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-lg"
                      style={{
                        width: "56px",
                        height: "56px",
                        background: agent?.agent_image
                          ? "unset"
                          : "var(--primary)",
                        color: "white",
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                      }}
                    >
                      {agent?.agent_image ? (
                        <img
                          src={agent.agent_image}
                          alt={agent.agent_name}
                          className="rounded-circle"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <IconRobot size={28} />
                      )}
                    </div>

                    <Dropdown align="end">
                      <Dropdown.Toggle
                        variant="link"
                        className="p-2 border-0 text-muted"
                        style={{ lineHeight: 1 }}
                      >
                        <IconDotsVertical size={20} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="border-0 shadow-lg dropdown-menu-scrollable">
                        {/*  {!isSubaccount() && (
                          <Dropdown.Item
                            className="d-flex align-items-center gap-2 py-2"
                            onClick={() => handleToggleAgentStatus(agent)}
                            disabled={isUpdatingStatus}
                          >
                            {agent.is_active ? (
                              <>
                                <IconToggleRight size={16} />
                                Desativar
                              </>
                            ) : (
                              <>
                                <IconToggleLeft size={16} />
                                Ativar
                              </>
                            )}
                          </Dropdown.Item>
                        )} */}
                        <Dropdown.Item
                          className="d-flex align-items-center gap-2 py-2"
                          onClick={() => handleOpenApiKeyModal(agent)}
                        >
                          <IconSettings size={16} />
                          Configurar
                        </Dropdown.Item>
                        {getUserPlan() !== 6 && (
                          <Dropdown.Item
                            className="d-flex align-items-center gap-2 py-2"
                            onClick={() => handleOpenConnectModal(agent)}
                            disabled={isLinking || isUnlinking}
                          >
                            {isLinking ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <IconPlug size={16} />
                            )}
                            {isLinking ? "Vinculando..." : "Conectar"}
                          </Dropdown.Item>
                        )}
                        {shouldShowLinkOption() && (
                          <Dropdown.Item
                            className="d-flex align-items-center gap-2 py-2"
                            onClick={() => handleLinkExistingAccount(agent)}
                            disabled={isLinking || isUnlinking}
                          >
                            {isLinking ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <IconPlugConnected size={16} />
                            )}
                            {isLinking ? "Vinculando..." : "Vincular"}
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item
                          className="d-flex align-items-center gap-2 py-2"
                          onClick={() => handleDisconnectAgent(agent)}
                          disabled={isLinking || isUnlinking}
                        >
                          {isUnlinking ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <IconPlugOff size={16} />
                          )}
                          {isUnlinking ? "Desvinculando..." : "Desvincular"}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {/* Agent Info */}
                  <h5 className="fw-semibold mb-1 text-dark text-capitalize d-flex align-items-center gap-2">
                    {agent.agent_name}
                    {(!agent.api_key || agent.api_key.trim() === "") && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-api-key-${agent.id}`}>
                            API Key não configurada. Configure a API Key para
                            ativar todas as funcionalidades do agente.
                          </Tooltip>
                        }
                      >
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: "20px",
                            height: "20px",
                            backgroundColor: "#ffc107",
                            color: "white",
                            cursor: "help",
                            fontSize: "10px",
                          }}
                        >
                          <IconKey size={12} />
                        </div>
                      </OverlayTrigger>
                    )}
                  </h5>

                  <p className="d-flex gap-2 text-muted small mb-3 text-capitalize">
                    {agent.agent_job}{" "}
                    {agent.wabotty_account &&
                      (() => {
                        const whatsappStatus = getWhatsappStatus(
                          agent.wabotty_account,
                          agent.id
                        );
                        return (
                          <Badge
                            bg={whatsappStatus?.color || "success"}
                            className="d-flex align-items-center gap-1 cursor-pointer"
                            style={{
                              fontSize: "9px",
                              padding: "4px 8px",
                              borderRadius: "8px",
                              height: "fit-content",
                            }}
                            title={`${
                              whatsappStatus?.text || "WhatsApp Conectado"
                            }: ${formatPhoneNumber(agent.wabotty_account)} - ${
                              whatsappStatus?.description ||
                              "Status não disponível"
                            }`}
                          >
                            <IconBrandWhatsapp size={12} />
                            <span style={{ marginLeft: "2px" }}>
                              {whatsappStatus?.text || "Conectado"}
                            </span>
                          </Badge>
                        );
                      })()}
                  </p>

                  {/* Version Badge and Hub Button */}
                  <div className="d-flex justify-content-between align-items-center">
                    <Badge
                      className="fw-medium"
                      style={{
                        fontSize: "10px",
                        padding: "6px 12px",
                        borderRadius: "12px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      v.{agent.version}
                    </Badge>
                    <Button
                      variant="success"
                      onClick={() => navigate(`/agents/${agent.id}/hub`)}
                      className="d-flex align-items-center gap-1"
                    >
                      <IconBrain size={16} />
                      Hub
                    </Button>
                  </div>
                </Card.Body>

                {/* Card Footer */}
                <Card.Footer className="bg-transparent border-top d-flex justify-content-between align-items-center p-3">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle"
                      style={{
                        width: "8px",
                        height: "8px",
                        backgroundColor: agent.is_active
                          ? "var(--success)"
                          : "var(--danger)",
                        animation: agent.is_active
                          ? "pulse 2s infinite"
                          : "none",
                      }}
                    />
                    <small
                      className="fw-medium"
                      style={{
                        color: agent.is_active
                          ? "var(--success)"
                          : "var(--danger)",
                      }}
                    >
                      {agent.is_active ? "Ativo" : "Inativo"}
                    </small>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                  
                    {canPerformAdminActions() && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-toggle-${agent.id}`}>
                            {agent.is_active
                              ? "Desativar agente"
                              : "Ativar agente"}
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant={
                            agent.is_active
                              ? "outline-warning"
                              : "outline-success"
                          }
                          className="d-flex align-items-center justify-content-center p-0"
                          onClick={() => handleToggleAgentStatus(agent)}
                          disabled={isUpdatingStatus}
                          style={{ width: "36px", height: "36px" }}
                        >
                          {agent.is_active ? (
                            <IconToggleRight size={18} />
                          ) : (
                            <IconToggleLeft size={18} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    )}

                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-edit-${agent.id}`}>
                          Editar agente
                        </Tooltip>
                      }
                    >
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="d-flex align-items-center justify-content-center p-0"
                        onClick={() => handleEditAgent(agent)}
                        style={{ width: "36px", height: "36px" }}
                      >
                        <IconEdit size={18} />
                      </Button>
                    </OverlayTrigger>

                   
                    {canPerformAdminActions() && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-duplicate-${agent.id}`}>
                            Duplicar agente
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="outline-info"
                          className="d-flex align-items-center justify-content-center p-0"
                          onClick={() => handleDuplicateAgent(agent)}
                          style={{ width: "36px", height: "36px" }}
                        >
                          <IconCopy size={18} />
                        </Button>
                      </OverlayTrigger>
                    )}

                    {canPerformAdminActions() && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-delete-${agent.id}`}>
                            {agent.is_active
                              ? "Desative o agente antes de excluir"
                              : "Excluir agente"}
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="outline-danger"
                          className="d-flex align-items-center justify-content-center p-0"
                          onClick={() => handleDeleteAgent(agent)}
                          disabled={agent.is_active}
                          style={{ width: "36px", height: "36px" }}
                        >
                          <IconTrash size={18} />
                        </Button>
                      </OverlayTrigger>
                    )}
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* Botão Carregar Mais */}
      {!isLoading && !isLoadingMore && hasMoreAgents && (
        <div className="d-flex justify-content-center py-4">
          <Button
            variant="outline-primary"
            onClick={loadMoreAgents}
            className="px-4 py-2 d-flex align-items-center gap-2"
            disabled={isLoadingMore}
          >
            <span>Carregar mais agentes</span>
            <span className="badge bg-primary ms-1">
              {showAgentsData.length} de {totalAgents}
            </span>
          </Button>
        </div>
      )}

      {/* Loading More Indicator */}
      {isLoadingMore && (
        <div className="d-flex flex-column align-items-center py-4 gap-2">
          <Spinner animation="border" variant="primary" size="sm" />
          <span className="text-muted">Carregando mais agentes...</span>
        </div>
      )}

      {/* Modal de Conectar Integração */}
      <Modal
        show={showConnectModal}
        onHide={handleCloseConnectModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <IconPlugConnected size={24} className="me-2 text-primary" />
            Conectar Integração
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!showWhatsappConnect ? (
            <div>
              <div className="text-center mb-4">
                <h5 className="mb-3">Integrações Disponíveis</h5>
                <p className="text-muted">
                  Conecte seu agente "{selectedAgentForConnect?.agent_name}" a
                  diferentes plataformas
                </p>
              </div>

              {/* Lista de Integrações */}
              <div className="integration-options">
                {/* WhatsApp Integration */}
                <Card className="mb-3 border integration-card-selectable">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-start">
                      <div className="integration-icon me-3">
                        <IconBrandWhatsapp size={40} className="text-success" />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-2">WhatsApp</h6>
                        <p className="text-muted mb-3 small">
                          Conecte seu agente ao WhatsApp para responder
                          mensagens automaticamente
                        </p>

                        {/* Verificar se pode conectar WhatsApp */}
                        {isLoadingFeature ? (
                          <div className="text-center py-3">
                            <Spinner animation="border" size="sm" className="me-2" />
                            <small className="text-muted">Verificando disponibilidade...</small>
                          </div>
                        ) : whatsappUsageRemaining !== null && whatsappUsageRemaining <= 0 && !selectedAgentForConnect?.wabotty_account ? (
                          <div className="whatsapp-restriction-message mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <IconAlertTriangle
                                size={20}
                                className="text-warning me-2"
                              />
                              <small className="text-warning fw-medium">
                                Limite de conexões atingido
                              </small>
                            </div>
                            <div className="alert alert-warning p-2 rounded mb-2">
                              <small className="text-dark">
                                <strong>
                                  Você atingiu o limite de conexões WhatsApp do seu plano.
                                </strong>
                                <br />
                                Contrate conexões adicionais por apenas{" "}
                                <strong>R$ 30,00/mês</strong> cada.
                              </small>
                            </div>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="mt-1"
                              onClick={handleManageIntegrations}
                            >
                              Gerenciar Integrações
                            </Button>
                          </div>
                        ) : selectedAgentForConnect?.wabotty_account ? (
                          <div className="connected-account mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <div className="status-dot bg-success me-2"></div>
                              <small className="text-success fw-medium">
                                Conta Conectada
                              </small>
                            </div>
                            <div className="account-info bg-light p-2 rounded">
                              <small className="text-muted">Número:</small>
                              <div className="fw-medium">
                                {formatPhoneNumber(
                                  selectedAgentForConnect.wabotty_account
                                )}
                              </div>
                            </div>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="mt-2"
                              onClick={handleManageIntegrations}
                            >
                              Gerenciar Integração
                            </Button>
                          </div>
                        ) : (
                          <div className="connect-form">
                            <Form.Group className="mb-3">
                              <Form.Label className="small fw-medium">
                                Número do WhatsApp
                              </Form.Label>
                              <NumberFormat
                                className="form-control"
                                format={(value) => {
                                  // Remove todos os caracteres não numéricos
                                  const cleanValue = value.replace(/\D/g, "");

                                  if (cleanValue.length === 0) return "";

                                  if (cleanValue.length <= 2) {
                                    return `(${cleanValue}`;
                                  } else if (cleanValue.length <= 6) {
                                    return cleanValue.replace(
                                      /(\d{2})(\d{0,4})/,
                                      "($1) $2"
                                    );
                                  } else if (cleanValue.length <= 10) {
                                    // Telefone fixo: (00) 0000-0000
                                    return cleanValue.replace(
                                      /(\d{2})(\d{4})(\d{0,4})/,
                                      "($1) $2-$3"
                                    );
                                  } else {
                                    // Telefone celular: (00) 00000-0000
                                    return cleanValue.replace(
                                      /(\d{2})(\d{5})(\d{0,4})/,
                                      "($1) $2-$3"
                                    );
                                  }
                                }}
                                mask="_"
                                placeholder="(00) 0000-0000 ou (00) 00000-0000"
                                value={phoneNumber}
                                onValueChange={(values) => {
                                  setPhoneNumber(values.formattedValue);
                                }}
                              />
                              <Form.Text className="text-muted">
                                Digite o número que será usado para conectar ao
                                WhatsApp. Aceita telefones fixos (10 dígitos) e
                                celulares (11 dígitos)
                              </Form.Text>
                            </Form.Group>
                            <Button
                              variant="success"
                              disabled={
                                isGeneratingSession ||
                                !phoneNumber ||
                                (phoneNumber.replace(/\D/g, "").length !== 10 &&
                                  phoneNumber.replace(/\D/g, "").length !== 11)
                              }
                              onClick={handleGenerateSession}
                              className="w-100"
                            >
                              {isGeneratingSession ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="me-2"
                                  />
                                  Iniciando sessão...
                                </>
                              ) : (
                                "Gerar QrCode de conexão"
                              )}
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          ) : (
            /* Componente WhatsappConnect quando gerar QR Code */

            <WhatsappConnect
              connectOrReconnect={{ current: "connect" }}
              phoneNumber={phoneNumber}
              agentId={selectedAgentForConnect?.id}
              onConnectionSuccess={handleConnectionSuccess}
              onConnectionFailure={handleConnectionFailure}
              setNotify={setNotify}
            />
          )}
        </Modal.Body>
        {!showWhatsappConnect && (
          <Modal.Footer className="bg-light">
            <div className="w-100 text-center">
              <small className="text-muted">
                Mais integrações serão adicionadas em breve
              </small>
            </div>
          </Modal.Footer>
        )}
      </Modal>

      {/* Modal de API Key */}
      <Modal
        show={showApiKeyModal}
        onHide={() => setShowApiKeyModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Configurações</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {defaultApiKey && (
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  id="use-default-api-key"
                  label="Usar API Key padrão"
                  checked={useDefaultApiKey}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setUseDefaultApiKey(isChecked);
                    if (isChecked) {
                      setApiKeyValue(defaultApiKey);
                    } else {
                      setApiKeyValue(selectedAgentForApiKey?.api_key || "");
                    }
                  }}
                  disabled={isUpdatingApiKey}
                />
                <Form.Text className="text-muted">
                  Usar a API Key padrão da conta configurada nas configurações
                  gerais.
                </Form.Text>
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>API Key da OpenAI</Form.Label>
              <Form.Control
                type="password"
                placeholder="sk-..."
                value={apiKeyValue}
                onChange={(e) => setApiKeyValue(e.target.value)}
                disabled={isUpdatingApiKey || useDefaultApiKey}
              />
              <Form.Text className="text-muted">
                Esta chave será usada para as requisições da OpenAI.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Modelo GPT</Form.Label>
              <Form.Select
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
                disabled={isUpdatingApiKey}
              >
                {/* <option value="gpt-4o-mini">gpt-4o-mini</option> */}
                <option value="gpt-4.1">gpt-4.1</option>
                <option value="gpt-4.1-mini">gpt-4.1-mini</option>
                {/*  <option value="gpt-5">gpt-5</option>
                <option value="gpt-5-mini">gpt-5-mini</option> */}
              </Form.Select>
              <Form.Text className="text-muted">
                Selecione o modelo GPT que será usado pelo agente.
              </Form.Text>
              <div className="d-flex justify-content-end mt-2">
                <Button
                  variant="primary"
                  size="sm"
                  className="p-2"
                  onClick={() => setShowModelsExplanationModal(true)}
                  style={{ fontSize: "12px" }}
                >
                  Por que apenas 2 modelos? 🤔
                </Button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="delay-checkbox"
                label="Ativar delay humanizado"
                checked={delayEnabled}
                onChange={(e) => setDelayEnabled(e.target.checked)}
                disabled={isUpdatingApiKey}
              />
              <Form.Text className="text-muted">
                Adiciona um delay antes de responder para tornar a conversa mais
                natural.
              </Form.Text>
            </Form.Group>

            {delayEnabled && (
              <Form.Group className="mb-3">
                <Form.Label>Tempo de delay (segundos)</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  max="60"
                  value={delayTime}
                  onChange={(e) => {
                    const value = Math.min(
                      60,
                      Math.max(1, parseInt(e.target.value) || 1)
                    );
                    setDelayTime(value);
                  }}
                  disabled={isUpdatingApiKey}
                />
                <Form.Text className="text-muted">
                  Tempo em segundos que o agente aguardará antes de responder
                  (máximo 60 segundos). <strong>Configuração apenas para o Whatsapp.</strong>
                </Form.Text>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowApiKeyModal(false)}
            disabled={isUpdatingApiKey}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveApiKey}
            disabled={isUpdatingApiKey || !apiKeyValue.trim()}
          >
            {isUpdatingApiKey ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Salvando...
              </>
            ) : (
              "Salvar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Notificações */}
      <Modal
        show={showNotificationsModal}
        onHide={() => setShowNotificationsModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Configurar Notificações</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingNotifications ? (
            <DefaultLoader isLoading={loadingNotifications} />
          ) : (
            <NotificationsModal
              initialData={notificationConfig}
              onSave={handleSaveNotificationConfig}
              onHide={() => setShowNotificationsModal(false)}
              show={showNotificationsModal}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Modal Explicativo dos Modelos */}
      <Modal
        show={showModelsExplanationModal}
        onHide={() => setShowModelsExplanationModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="d-flex align-items-center gap-2">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "40px",
                height: "40px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
              }}
            >
              🧠
            </div>
            Por que usamos apenas esses 2 modelos?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#e8f4fd",
                  color: "#1976d2",
                }}
              >
                🎯
              </div>
              <div>
                <h5 className="mb-1 text-primary">Estabilidade e Precisão</h5>
                <p className="text-muted mb-0 small">
                  Garantimos a melhor experiência para seus agentes
                </p>
              </div>
            </div>

            <p className="mb-4" style={{ lineHeight: "1.6" }}>
              Para garantir que{" "}
              <strong>
                cada agente funcione com estabilidade, precisão e respostas
                realmente inteligentes
              </strong>
              , adotamos exclusivamente os{" "}
              <strong>modelos GPT-4 e GPT-4.1 Mini</strong>.
            </p>

            <div className="row g-4">
              <div className="col-md-6">
                <div
                  className="p-3 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div
                      className="bg-success text-white rounded-circle p-1"
                      style={{
                        width: "24px",
                        height: "24px",
                        fontSize: "12px",
                      }}
                    >
                      ✓
                    </div>
                    <strong className="text-success">Melhor Equilíbrio</strong>
                  </div>
                  <ul className="mb-0 small text-muted ps-3">
                    <li>Capacidade de raciocínio avançada</li>
                    <li>Consistência nas respostas</li>
                    <li>Baixa taxa de erros em fluxos longos</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="p-3 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div
                      className="bg-primary text-white rounded-circle p-1"
                      style={{
                        width: "24px",
                        height: "24px",
                        fontSize: "12px",
                      }}
                    >
                      🔧
                    </div>
                    <strong className="text-primary">Ideal para Agentes</strong>
                  </div>
                  <ul className="mb-0 small text-muted ps-3">
                    <li>Segue regras detalhadas perfeitamente</li>
                    <li>Interpreta contextos complexos</li>
                    <li>Mantém personalidade consistente</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#fff3e0",
                  color: "#f57c00",
                }}
              >
                ⚠️
              </div>
              <div>
                <h5 className="mb-1 text-warning">
                  Por que não outros modelos?
                </h5>
                <p className="text-muted mb-0 small">
                  Limitações que afetam a qualidade dos agentes
                </p>
              </div>
            </div>

            <div
              className="p-3 rounded"
              style={{
                backgroundColor: "#fff8e1",
                border: "1px solid #ffcc02",
              }}
            >
              <p className="mb-2">
                <strong>Outros modelos</strong> como <code>4o-mini</code> ou{" "}
                <code>GPT-5</code> são ótimos para tarefas rápidas, mas{" "}
                <strong>
                  ainda não apresentam o mesmo nível de confiabilidade
                </strong>{" "}
                para operações mais profundas.
              </p>
              <p className="mb-0 small text-muted">
                Em cenários exigentes, isso pode gerar{" "}
                <strong>quebras de fluxo</strong> e{" "}
                <strong>respostas imprecisas</strong>
                que prejudicariam a experiência do seu cliente.
              </p>
            </div>
          </div>

          <div>
            <div className="d-flex align-items-center gap-3 mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#e8f5e8",
                  color: "#2e7d32",
                }}
              >
                🚀
              </div>
              <div>
                <h5 className="mb-1 text-success">Novas LLM's no Agentes 2.0</h5>
              
              </div>
            </div>

            <div
              className="p-3 rounded"
              style={{
                backgroundColor: "#e8f5e8",
                border: "1px solid #4caf50",
              }}
            >
              <p className="mb-0">
               Novas LLM's como Claude e Gemini estão disponíveis no Agentes 2.0! 🎉
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="primary"
            onClick={() => setShowModelsExplanationModal(false)}
            className="px-4"
          >
            Entendi! ✨
          </Button>
        </Modal.Footer>
      </Modal>

      {/* AgentChat */}
      {showAgentChat && selectedAgentForChat && (
        <AgentChat
          agentData={selectedAgentForChat}
          onClose={() => setShowAgentChat(false)}
        />
      )}

      {/* Estilos CSS para o modal de conectar */}
      <style>{`
        .integration-card-selectable {
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .integration-card-selectable:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #007bff !important;
        }

        .integration-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .status-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        .account-info {
          border: 1px solid #e9ecef;
        }

        .dropdown-menu-scrollable {
          max-height: 280px;
          overflow-y: auto;
          min-width: 180px;
          border-radius: 12px !important;
          padding: 8px 0;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
        }

        .dropdown-menu-scrollable .dropdown-item {
          border-radius: 8px;
          margin: 2px 8px;
          padding: 10px 12px;
          transition: all 0.15s ease;
          font-size: 14px;
          font-weight: 500;
        }

        .dropdown-menu-scrollable .dropdown-item:hover {
          background-color: #f8f9fa;
          transform: translateX(2px);
        }

        .dropdown-menu-scrollable .dropdown-item.text-danger:hover {
          background-color: #fff5f5;
          color: #dc3545 !important;
        }

        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }

        .connect-form .form-control:focus {
          border-color: #25d366;
          box-shadow: 0 0 0 0.2rem rgba(37, 211, 102, 0.25);
        }

        .integration-card-hover {
          transition: all 0.3s ease;
          border-radius: 12px;
        }

        .integration-card-hover:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          border-color: var(--primary) !important;
        }

        .integration-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          background: rgba(var(--primary-rgb), 0.1);
          border-radius: 12px;
        }
      `}</style>
    </BSContainer>
  );
}
